import { render, staticRenderFns } from "./GeRenXinXiShouQuan.vue?vue&type=template&id=4e509280&scoped=true&"
var script = {}
import style0 from "./GeRenXinXiShouQuan.vue?vue&type=style&index=0&id=4e509280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e509280",
  null
  
)

export default component.exports